// @ts-expect-error Lexxy does not have types
import { Extension } from "@37signals/lexxy"

// Adds a save button to the end of the toolbar.
// Disabled by default: only editors configured with `save-button` opt in.
export default class SaveButtonExtension extends Extension {
  declare editorElement: HTMLElement & { config: { get(path: string): unknown } }

  get enabled() {
    return this.editorElement.config.get("save_button") === true
  }

  initializeToolbar(toolbar: HTMLElement) {
    toolbar.append(this.#createSaveButton())
  }

  #createSaveButton() {
    const button = document.createElement("button")
    button.type = "submit"
    button.title = "Save"
    button.dataset.preventOverflow = "true"
    button.className = "lexxy-editor__toolbar-button note-submit"
    button.setAttribute("form", this.editorElement.closest("form")?.id ?? "")
    button.innerHTML = `<i class="fa-regular fa-fw fa-lg" aria-hidden="true"></i>`
    return button
  }
}
